import "./App.css";

import { Box, Fab } from "@material-ui/core";
import classNames from "classnames";
import { Suspense } from "react";

import { useStyles } from "./app.style";
import Header from "./presentation/header/Header";
import Footer from "./presentation/footer";
import Routing from "./routing";
import { Toaster } from "react-hot-toast";
import ScrollTop from "./presentation/shared/ScrollTop";
import { KeyboardArrowUp } from "@material-ui/icons";

function App() {
  const classes = useStyles();
  return (
    <div className={classNames(classes.root)}>
      <Header />
      <div className={classNames(classes.mainContent)}>
        <Suspense fallback="">
          <div style={{ display: "flex" }}>
            <Routing />
          </div>
        </Suspense>
      </div>

      <Box
        mt={5}
        display="flex"
        justifyContent="space-between"
        alignItems="center"
      >
        <Footer {...{ classes }} />
      </Box>
      <Toaster position="top-right" />
      <ScrollTop>
        <Fab color="default" size="small" aria-label="scroll back to top">
          <KeyboardArrowUp />
        </Fab>
      </ScrollTop>
    </div>
  );
}

export default App;
